export const MAX_DISPLAY_MAP_PREVIEW_ONBOARDING_COUNT = 3;
export const MAP_PREVIEW_ONBOARDING_COOKIE_KEY = 'map_preview_onboarding_counter';
